import React, { useMemo } from "react";

import { debounce } from "lodash";

import { logEvent } from "@internal/analytics";
import { SecondaryButton } from "@shared/buttons";

interface TableSearchFilterProps {
  textFilter: string;
  setTextFilter: (arg0: string) => void;
}

export const TableSearchFilter = ({
  textFilter,
  setTextFilter,
}: TableSearchFilterProps) => {
  const debouncedFn = useMemo(
    () =>
      debounce((text: string) => {
        setTextFilter(text);
        logEvent("Used Text Filter", { text });
      }, 500),
    [setTextFilter],
  );

  const updateText = (text: string) => {
    setTextFilter(text);
    debouncedFn(text);
  };

  return (
    <div className="flex">
      <input
        placeholder="Filter rows by name..."
        className="form-control mr-2"
        value={textFilter}
        onChange={(e) => updateText(e.target.value)}
      />
      <SecondaryButton onClick={() => updateText("")}>
        CLEAR FILTER
      </SecondaryButton>
    </div>
  );
};
